<script>
import { mapState } from "pinia";

import { useContextStore } from "@/store/context";
import Container from "@/components/atoms/container";
import Connexion from "@/containers/connexion";
import PageNotFound from "@/containers/page-not-found";
import { StatusTypes as AuthStatusTypes, useAuthStore } from "@/store/auth";
import { useErrorPagesTracking } from "@/mixins/tracking/error-pages";

export default defineNuxtComponent({
  components: { Connexion, Container, PageNotFound },
  props: {
    error: {
      type: Object,
      required: false,
      default: {
        statusCode: 500
      }
    }
  },
  setup() {
    const { trackError } = useErrorPagesTracking();
    return { trackError };
  },
  computed: {
    ...mapState(useContextStore, ["layout"]),
    ...mapState(useAuthStore, { authStatus: "status" }),
    component() {
      return defineAsyncComponent(
        lazyComponents[`/components/pages/maintenance/${this.layout}.vue`]
      );
    },
    statusCode() {
      return this.error && this.error.statusCode ? +this.error.statusCode : 500;
    },
    redirectionPath() {
      return this.error.data &&
        this.error.data.to &&
        this.error.data.to.fullPath
        ? this.error.data.to.fullPath
        : null;
    }
  },
  watch: {
    authStatus: {
      handler(status) {
        if (status === AuthStatusTypes.CONNEXION_COMPLETE) {
          this.connected();
        }
      }
    }
  },
  methods: {
    connected() {
      if (this.redirectionPath) {
        this.$router.replace(this.redirectionPath);
      } else {
        this.$router.go(this.redirectionPath);
      }
    }
  },
  mounted() {
    this.trackError(this.error.statusCode);
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 0);
  }
});
</script>

<template>
  <div
    v-if="statusCode === NUXT_SERVER_INIT_ERROR_CODE || statusCode === NUXT_SERVER_INIT_TEMP_ERROR_CODE"
    class="u-bgcolor-white u-flex u-viewport-height u-flex-align-center u-flex-justify-center"
  >
    <component
      :is="component"
      :is-temp="statusCode === NUXT_SERVER_INIT_TEMP_ERROR_CODE"
    />
  </div>
  <div v-else>
    <NuxtLayout>
      <div class="u-bgcolor-white">
        <Container v-if="statusCode === 401">
          <h1 class="u-text-center u-mb-md u-pt-md">
            Merci de vous connecter pour accéder à cette page
          </h1>
          <Connexion :popin="false" />
        </Container>
        <Container v-else-if="statusCode === 404">
          <PageNotFound />
        </Container>
        <Container v-else>
          <component
            :is="component"
            :is-temp="statusCode === 504"
          />
        </Container>
      </div>
    </NuxtLayout>
  </div>
</template>
